export default __webpack_public_path__ + "static/media/T660_E_BD.95079862.pdf";